import { type SVGProps } from "react";

interface DragAndDropIconProps extends Omit<
	SVGProps<SVGSVGElement>,
	"width" | "height"
> {
	width?: number | string;
	height?: number | string;
}

const SvgComponent = ({
	width = 48,
	height = 48,
	className,
	style,
	...props
}: DragAndDropIconProps) => {
	const size = typeof width === "number" ? `${width}px` : width;
	const heightSize = typeof height === "number" ? `${height}px` : height;

	return (
		<div
			className={`flex flex-col items-center justify-center rounded-full ${className || ""}`}
			style={{
				width: size,
				height: heightSize,
				background: "rgba(0, 116, 221, 0.09)",
				...style,
			}}
		>
			<svg
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				{...props}
			>
				<path
					d="M20.7505 18.0005C20.7505 16.4817 19.5183 15.2495 17.9995 15.2495C16.481 15.2498 15.25 16.4819 15.25 18.0005C15.2503 19.5189 16.4811 20.7497 17.9995 20.75C19.5181 20.75 20.7502 19.519 20.7505 18.0005ZM10 14.2505L10.1509 14.2651C10.4928 14.335 10.75 14.638 10.75 15.0005C10.7498 15.3628 10.4926 15.6645 10.1509 15.7344L10 15.7505H8.00049C7.58644 15.7505 7.25075 15.4145 7.25049 15.0005C7.25049 14.5863 7.58627 14.2505 8.00049 14.2505H10ZM14.0005 10.25L14.1514 10.2646C14.4931 10.3346 14.7505 10.6376 14.7505 11C14.7505 11.3624 14.4931 11.6654 14.1514 11.7354L14.0005 11.75H8.00049C7.58627 11.75 7.25049 11.4142 7.25049 11C7.25049 10.5858 7.58627 10.25 8.00049 10.25H14.0005ZM19.2505 10.5005V6.80029C19.2505 5.94784 19.2487 5.35277 19.2109 4.89014C19.1739 4.43681 19.1049 4.17641 19.0044 3.979C18.7887 3.55564 18.4448 3.21034 18.0215 2.99463C17.824 2.89406 17.5626 2.82515 17.1089 2.78809C16.6464 2.75033 16.0523 2.75 15.2002 2.75H8.80029C7.94784 2.75 7.35277 2.75029 6.89014 2.78809C6.43706 2.82514 6.17637 2.8942 5.979 2.99463C5.55564 3.21034 5.21034 3.55564 4.99463 3.979C4.8942 4.17637 4.82514 4.43706 4.78809 4.89014C4.75029 5.35277 4.75 5.94784 4.75 6.80029V17.2007C4.75 18.0528 4.7503 18.6469 4.78809 19.1094C4.82517 19.5632 4.89399 19.8245 4.99463 20.022C5.21035 20.4453 5.55569 20.7892 5.979 21.0049C6.17639 21.1054 6.43693 21.1744 6.89014 21.2114C7.35277 21.2492 7.94784 21.2495 8.80029 21.2495H11.5C11.9141 21.2495 12.2497 21.5855 12.25 21.9995C12.25 22.4137 11.9142 22.7495 11.5 22.7495H8.80029C7.97262 22.7495 7.30643 22.751 6.76855 22.707C6.22195 22.6624 5.74205 22.5671 5.29785 22.3408C4.59242 21.9814 4.01823 21.4085 3.65869 20.7031C3.43235 20.2589 3.33861 19.7776 3.29395 19.231C3.25005 18.6933 3.25 18.0278 3.25 17.2007V6.80029C3.25 5.97259 3.25 5.30644 3.29395 4.76855C3.3386 4.22204 3.43245 3.74199 3.65869 3.29785C4.01822 2.59224 4.59224 2.01822 5.29785 1.65869C5.74199 1.43245 6.22204 1.3386 6.76855 1.29395C7.30644 1.25 7.97259 1.25 8.80029 1.25H15.2002C16.0278 1.25 16.6941 1.25 17.2319 1.29395C17.7784 1.33862 18.2586 1.43242 18.7026 1.65869C19.4082 2.01822 19.9823 2.59228 20.3418 3.29785C20.568 3.74194 20.6619 4.22211 20.7065 4.76855C20.7505 5.30643 20.7505 5.9726 20.7505 6.80029V10.5005C20.7502 10.9143 20.4143 11.2502 20.0005 11.2505C19.5864 11.2505 19.2508 10.9145 19.2505 10.5005ZM16 6.24951C16.4141 6.24951 16.7497 6.58552 16.75 6.99951C16.75 7.41373 16.4142 7.74951 16 7.74951H8.00049C7.58627 7.74951 7.25049 7.41373 7.25049 6.99951C7.25075 6.58552 7.58644 6.24951 8.00049 6.24951H16ZM22.2505 18.0005C22.2504 18.9027 21.9653 19.7368 21.4858 20.4248L22.5303 21.4692C22.8231 21.7621 22.8229 22.2369 22.5303 22.5298C22.2739 22.7861 21.8781 22.8189 21.5869 22.6265L21.4697 22.5298L20.4253 21.4854C19.7371 21.9652 18.9021 22.25 17.9995 22.25C15.6527 22.2497 13.7503 20.3473 13.75 18.0005C13.75 15.6534 15.6525 13.7498 17.9995 13.7495C20.3467 13.7495 22.2505 15.6533 22.2505 18.0005Z"
					fill="#003261"
					fillOpacity="0.702"
				/>
			</svg>
		</div>
	);
};

export { SvgComponent as NoResultsIcon };
